import React from "react";
import {Controller, FormProvider, useForm} from "react-hook-form";
import {Paper, TextField} from "@mui/material";
import {ForgotPasswordFormProps, ForgottenPasswordEmail} from "./types";
import {LoadingButton} from "@mui/lab";
import axios from "axios";
import ForgottenPasswordCancelLink from "./ForgottenPasswordCancelLink";
import {useEmailValidation} from "../../service/useEmailValidation";
import {useLxTranslations} from "@lxo-blocks/react";
import {FORGOT_PASSWORD_FORM_TRANSLATION} from "./ForgotPasswordForm.translation.de";

export default function ForgotPasswordForm(forgotPasswordProps: ForgotPasswordFormProps) {

    const formMethods = useForm<ForgottenPasswordEmail>({
        mode: "all",
    });
    const {t} = useLxTranslations(FORGOT_PASSWORD_FORM_TRANSLATION);

    const {validateEmail} = useEmailValidation();

    const {handleSubmit, formState, control} = formMethods;
    const {isSubmitting, errors} = formState;

    async function submitEmail(forgottenPasswordEmail: ForgottenPasswordEmail) {
        try {
            await axios.post("/grld-public/forgotpassword/v100/request", forgottenPasswordEmail);
            forgotPasswordProps.successHandler.onSuccess(forgottenPasswordEmail);
        } catch (ex) {
        }
    }

    return (<>
            <Paper sx={{px: 8, py: 5}}>
                <FormProvider {...formMethods}>
                    <form onSubmit={handleSubmit(submitEmail)}>
                        <Controller
                            control={control}
                            name="email"
                            defaultValue=""
                            rules={{
                                required: t("VALID_EMAIL_IS_REQUIRED").toString(),
                                validate: validateEmail
                            }}
                            render={(props: any) => {
                                return (<TextField
                                    {...props}
                                    sx={{mb: 3}}
                                    fullWidth
                                    label={t("EMAIL")}
                                    inputProps={{
                                        "aria-label": "email",
                                        autoComplete: "nope",
                                    }}
                                    error={!!errors.email}
                                    helperText={
                                        errors.email?.message && errors.email.message
                                    }
                                    variant="outlined"
                                />);
                            }}/>

                        <LoadingButton
                            sx={{py: 1}}
                            variant="contained"
                            color="primary"
                            type="submit"
                            fullWidth
                            disabled={isSubmitting || !!errors.email}
                            loading={isSubmitting}
                            loadingPosition="end"
                            endIcon={<></>}
                        >
                            {isSubmitting
                                ? t("FORGOT_PASSWORD_BUTTON_LABEL_IS_SUBMITTING")
                                : t("FORGOT_PASSWORD_BUTTON_LABEL_SEND")}
                        </LoadingButton>
                    </form>
                </FormProvider>
            </Paper>
            <ForgottenPasswordCancelLink sx={{pt: 3, pb: 1}}/>
        </>
    );
}
